module.exports = __webpack_public_path__ + "static/media/nav-icon--coupons.fa2236d9.svg";